export default "__VITE_ASSET__C7TvFb6___"